@if (is_loading) {
  <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
}

<div style="width: 950px;margin-left: 40px; margin-top: 40px"
     ngClass.xs="page-margin-xs"
     ngClass.sm="page-margin-sm"
     ngClass="page-margin">

  <div>
    <mat-list>
      <mat-list-item>Campaign Groups</mat-list-item>
      <mat-divider></mat-divider>
    </mat-list>
  </div>



  @if (campaign_group_sequence_id=='') {
    <ng-container>
      <span>Must select Campaign Group Sequence</span>
    </ng-container>
  }


  @if (client_id && campaign_group_sequence_id) {
  <ng-container>

<!--    <div>-->
<!--      <mat-list>-->
<!--        <mat-list-item>Campaigns</mat-list-item>-->
<!--        <mat-divider></mat-divider>-->
<!--      </mat-list>-->
<!--    </div>-->

  <div [hidden]="is_loading">

    <div style="margin-top: 20px; margin-bottom: 20px;">

      <ng-container>
        <button mat-fab aria-label="Add Campaign Group" (click)="addCampaignGroup(false)" matTooltip="Add Campaign Group"
                matTooltipPosition="right">
          <mat-icon class="add-button">add</mat-icon>
        </button>
      </ng-container>
    </div>

    <div>
      <mat-form-field>
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
      </mat-form-field>

      <div ngClass="table-width" ngClass.xs="table-width-xs" ngClass.sm="table-width-sm">
        <mat-card class="mat-elevation-z24">
          <div class="mat-elevation-z24">
            <table mat-table [dataSource]="dataSource" matSort>

              <!-- Campaign Group ID Column -->
              <ng-container matColumnDef="campaign_group_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Campaign Group ID</th>
                <td mat-cell *matCellDef="let row">{{row.campaign_group_id}}</td>
              </ng-container>

              <!-- Client Name Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Campaign Group Name</th>
                <td mat-cell *matCellDef="let row">{{row.name}}</td>
              </ng-container>

              <!-- Campaign Type Column -->
              <ng-container matColumnDef="campaign_type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Campaign Type</th>
                <td mat-cell *matCellDef="let row">{{row.campaign_type}}</td>
              </ng-container>

              <!-- Status Column -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                <td mat-cell *matCellDef="let row">{{row.status}}</td>
              </ng-container>

              <!-- View Column -->
              <ng-container matColumnDef="View">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>View</th>
                <td mat-cell *matCellDef="let row">
                  <button mat-icon-button class="any-icon-primary table-icon" (click)="viewData(row)">
                    <mat-icon color="accent">visibility</mat-icon>
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="Edit">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Edit</th>
                <td mat-cell *matCellDef="let row">
                  <button mat-icon-button class="any-icon-primary table-icon" (click)="addCampaignGroup(true,  row)">
                    <mat-icon color="accent" style="cursor: pointer;">edit</mat-icon>
                  </button>
                </td>
              </ng-container>



              <!-- Delete Column -->
              <ng-container matColumnDef="Delete">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Delete</th>
                <td mat-cell *matCellDef="let row">
                  <button mat-icon-button class="warn-icon-primary table-icon" (click)="deleteRow(row)">
                    <mat-icon color="warn" style="cursor: pointer;">delete</mat-icon>
                  </button>
                </td>
              </ng-container>


              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="element-row"
                  (click)="getTableRecord(row)"></tr>
            </table>


            <mat-paginator [pageSizeOptions]="[5, 10, 20]"
                           showFirstLastButtons
                           aria-label="Select page of periodic elements">
            </mat-paginator>
          </div>
        </mat-card>
      </div>
    </div>
  </div>

  </ng-container>
  }


  @if (client_id && campaign_group_sequence_id) {

  <mat-card style="margin-top: 20px">
    <mat-card-content>
      @if (isDataLoaded) {
        <highcharts-chart
          [Highcharts]="Highcharts"
          [options]="chartOptions"

          style="width: 100%; height: 400px; display: block;"
        ></highcharts-chart>
      }
    </mat-card-content>
  </mat-card>

    <mat-card style="margin-top: 20px">
      <mat-card-content>
        @if (isDataHhmmLoaded) {
          <highcharts-chart
            [Highcharts]="Highcharts"
            [options]="chartHhmmOptions"
            style="width: 100%; height: 400px; display: block;"
          ></highcharts-chart>
        }
      </mat-card-content>
    </mat-card>


  }





</div>
